'use strict';

import angular from 'angular';


export default function($timeout, $http, $filter, $compile, $scope, toastr, pusher) {
	'ngInject';

	const vm = this;

	vm.reserveListsLocked = false;
	vm.disabledUsers = {};
	vm.data = {};

	let _channel;
	let _isInitiated = false;

	function _initiate() {
		if (!_isInitiated) {
			_isInitiated = true;
			_channel = pusher.subscribe(`presence-entity-beats-callout-${vm.data.viewer.entity.uuid}`);

			function _reloadCalloutData() {
				_loadData({
					query: [
						{name: 'beats_callouts'},
					],
				});
			}
			_channel.ready.promise.then(_reloadCalloutData);
			_channel.$bind('refresh', _reloadCalloutData);
			if (vm.data.beats_callouts.latest_callout_team) {
				vm.calloutState = 'LATEST_CALLOUT';
			} else {
				vm.calloutState = 'FRESH';
			}
		}
	}

	function _loadData(fields) {
		if (vm.loadingData) return;
		vm.loadingData = true;
		$http({
			method: 'POST',
			url: '/api/mappy/',
			data: fields,
		}).then((response) => {
			Object.assign(vm.data, response.data.result);
			_initiate();
		}, (error) => {
			console.error(error);
		}).finally(() => {
			vm.loadingData = false;
		});
	}

	function _refreshData() {
		_loadData({
			query: [
				{name: 'viewer'},
				{name: 'beats'},
				{name: 'beats_reserve_lists'},
				{name: 'beats_callouts'},
				{name: 'teams'},
			],
		});
	}

	_refreshData();

	vm.disableUser = function(user) {
		vm.disabledUsers[user.uuid] = user;
	}

	vm.enableUser = function(user) {
		delete vm.disabledUsers[user.uuid];
	}

	vm.updateReserveListNotes = function(reserve_list, notes) {
		const oldNotes = reserve_list.notes;
		reserve_list._notes_saving = true;
		$http({
			method: 'POST',
			url: '/api/teams/beats/reserve_lists/update_notes/',
			data: {
				reserve_list_id: reserve_list.uuid,
				body: notes,
			}
		}).then(() => {
			const message = `Updated notes for ${reserve_list.name}.`;
			reserve_list.notes = notes;
			reserve_list.notes_last_updated_by = 'you';
			toastr.success(message);
		}, () => {
			toastr.error('Unable to save notes');
			reserve_list.notes = oldNotes;
		}).finally(() => {
			reserve_list._notes_saving = false;
		});
	}

	function _buildPreInput(taskType) {
		const data = angular.copy(vm.data);
		const requiredReserveLists = {};
		return {
			task_type: taskType,
			requests: data.beats.filter((beat) => {
				return beat._selected;
			}).map((beat) => {
				const reserve_list_ref = beat.reserve_list ? beat.reserve_list.uuid : null;
				if (reserve_list_ref) requiredReserveLists[reserve_list_ref] = true;
				return {
					beat_id: beat.uuid,
					reserve_list_ref: reserve_list_ref,
					call_profiles: beat.call_profiles.filter((profile) => {
						return !vm.disabledUsers[profile.user.uuid];
					}).map((profile) => {
						return {
							user_id: profile.user.uuid,
							start_seconds: profile.start_seconds,
							stop_seconds: profile.stop_seconds,
						};
					}),
					assignment_message: beat.assignment_message,
				};
			}),
			reserve_lists: data.beats_reserve_lists.filter((reserveList) => {
				return !!requiredReserveLists[reserveList.uuid];
			}).map((reserveList) => {
				return {
					ref: reserveList.uuid,
					name: reserveList.name,
					call_method: reserveList.call_method,
					target_call_count: reserveList.target_call_count,
					user_ids: reserveList.profiles.filter((profile) => {
						return !vm.disabledUsers[profile.user.uuid];
					}).map((profile) => {
						return profile.user.uuid;
					}),
				};
			}),
		};
	}

	function _createCalls(input) {
		return $http({
			method: 'POST',
			url: '/api/teams/beats/callout/initiate/',
			data: input,
		}).then((response) => {
			console.log(response);
			vm.calloutState = 'LATEST_CALLOUT';
		}, (error) => {
			console.log(error);
		})
	}

	vm.createCallsWithName = function(taskType, teamName) {
		const requestInput = _buildPreInput(taskType);
		requestInput.team_name = teamName;
		console.log(requestInput);
		_createCalls(requestInput);
	}

	vm.pauseCalls = function(calloutId) {
		return $http({
			method: 'POST',
			url: '/api/teams/beats/callout/pause/',
			data: {callout_id: calloutId },
		}).then((response) => {
			toastr.success('Calls pausing.');
		}, (error) => {
			console.log(error);
		})
	}

	vm.resumeCalls = function(calloutId) {
		return $http({
			method: 'POST',
			url: '/api/teams/beats/callout/resume/',
			data: {callout_id: calloutId },
		}).then((response) => {
			toastr.success('Calls resuming.');
		}, (error) => {
			console.log(error);
		})
	}
}
